
const triggerVerifyStateFactor = (country ,lang ,otp, sessionId ,externalRefId,stateToken , deviceType) => {
    lang = getLocalLanguage(lang)
     const Headers = {
         "Content-Type": `application/json`,
          "x-wu-correlationId": sessionId,
          "x-wu-externalRefId": externalRefId,
           "WuCountryCode": country,
           "WuLanguageCode": lang,
           "x-wu-operationName": "verifyStateFactor",
           "Accept-Language": `${lang}-${country}`,
           "WuCountryCode": country,
           "WuLanguageCode": lang,
           "x-wu-sessionId": sessionId,
           "accept": `application/json`,
           "DEVICEDETAILS":"Browser",
           "platform":"nextgen",
           "DISPLAYSYSTEM":"Web",
           "isrrenabled":false
       };
 
     const verifyStateFactorBody = 
         {
            "otp": otp,
            "deviceAuthType": deviceType,
            "stateToken": stateToken
         }
     
 
     const requestOptions = {
         method: "POST",
         body: JSON.stringify(verifyStateFactorBody),
         headers: Headers
     };
 
     try {
         return fetchApiWu('/auth/v2/state/factor/verify', requestOptions, 'verifyStateFactor')
             .then((response) => {
                return response               
             })
     } catch(e) {
         console.log(e);
         return "error"
         
     }
     
 };

window.queryData.triggerVerifyStateFactor = triggerVerifyStateFactor;